import React, { useState } from "react";
import { SITE_BRAND, SITE_DOMAIN } from "../config/site";

const publicBase = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
/** Cache-bust: forzare ricarico dopo ripristino marchio brochure */
const LOGO_ASSET_V = "20260922b";
const LOGO_CORRETTO = `${publicBase}/6amico-logo-corretto.png?v=${LOGO_ASSET_V}`;
const LOGO_FALLBACK = `${publicBase}/logo-6amico.svg?v=${LOGO_ASSET_V}`;

/**
 * Logo ufficiale 6amico — marchio brochure (6 verde + AMICO).
 * File: public/6amico-logo-corretto.png
 */
export default function BrandLogo({
  className = "",
  compact = false,
  showDomain = false,
  homeButton = false,
  variant = "default",
}) {
  const isHeader = variant === "header";
  const isHero = variant === "hero" || homeButton;
  const [src, setSrc] = useState(LOGO_CORRETTO);

  const heightClass = isHeader || (!isHero && !compact)
    ? "h-10"
    : isHero
    ? "h-12"
    : "h-9";

  return (
    <span
      className={`brand-logo-6amico inline-flex items-center shrink-0 ${isHeader ? "brand-logo-6amico--header" : ""} ${isHero ? "brand-logo-6amico--home" : ""} ${className}`}
      data-testid="brand-logo"
    >
      <img
        src={src}
        alt={SITE_BRAND}
        decoding="async"
        className={`${heightClass} w-auto object-contain object-left shrink-0`}
        onError={() => {
          if (src !== LOGO_FALLBACK) setSrc(LOGO_FALLBACK);
        }}
      />
      <span className="sr-only">{showDomain ? SITE_DOMAIN : SITE_BRAND}</span>
    </span>
  );
}
